import Vue from "vue";
import VueRouter from "vue-router";
import { setCookie, getCookie } from "@/utils/cookieinfo";

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const routes = [
  {
    path: "/",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/login.vue"),
  },
  // 海报静态页面模块
  {
    path: "/holdMeetPoster",
    name: "holdMeetPoster",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/poster/holdMeeting.vue"),
  },
  {
    path: "/test",
    name: "test",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/test/index.vue"),
  },
  {
    path: "/aiNote",
    name: "aiNote",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/aiNote.vue"),
  },
  {
    path: "/holdMeetCard",
    name: "holdMeetCard",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/poster/holdMeetCard.vue"),
  },
  {
    path: "/userCardPoster",
    name: "userCardPoster",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/poster/userCard.vue"),
  },
  {
    path: "/haveMeetPoster",
    name: "haveMeetPoster",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/poster/haveMeetPoster.vue"
      ),
  },
  {
    path: "/webToMini",
    name: "webToMini",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/webToMini/webToMini.vue"),
  },
  {
    path: "/webToMiniHome",
    name: "webToMiniHome",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/webToMini/webToMiniHome.vue"
      ),
  },

  {
    path: "/webToMiniByWeMeet",
    name: "webToMiniByWeMeet",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/webToMini/webToMiniByWeMeet.vue"
      ),
  },
  {
    path: "/webToMiniHomeByWeMeet",
    name: "webToMiniHomeByWeMeet",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/webToMini/webToMiniHomeByWeMeet.vue"
      ),
  },
  // adm 内页单独定制链接
  {
    path: "/webToAdm",
    name: "webToAdm",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/webToMini/webToAdm.vue"),
  },
  {
    path: "/webToAdmCode",
    name: "webToAdmCode",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/webToMini/webToAdmCode.vue"
      ),
  },
  {
    path: "/webToAdmRegister",
    name: "webToAdmRegister",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/webToMini/webToAdmRegister.vue"
      ),
  },
  {
    path: "/webToAdmQuestion",
    name: "webToAdmQuestion",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/webToMini/webToAdmQuestion.vue"
      ),
  },

  {
    path: "/webToMyTicket",
    name: "webToMyTicket",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/webToMini/webToMyTicket.vue"
      ),
  },

  {
    path: "/test",
    name: "test",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/login.vue"),
  },
  {
    path: "/aigc",
    name: "aigc",
    component: () => import(/* webpackChunkName: "about" */ "@/views/aigc.vue"),
  },
  {
    // 展会现场签到海报
    path: "/exhibitionSignCode",
    name: "exhibitionSignCode",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/poster/exhibitionSignCode.vue"
      ),
  },
  {
    // 展会详情码
    path: "/exhibitionPoster",
    name: "exhibitionPoster",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/poster/exhibitionPoster.vue"
      ),
  },

  {
    // 办个会/论坛签到码
    path: "/forumOrMeetSign",
    name: "forumOrMeetSign",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/poster/forumOrMeetSign.vue"
      ),
  },
  // 电博会 临时注册地址
  {
    path: "/visitorRegister",
    name: "visitorRegister",
    component: () => import("@/views/register-form/visitorRegister"),
  },
  {
    path: "/mideaRegister",
    name: "mideaRegister",
    component: () => import("@/views/register-form/mideaRegister"),
  },
  {
    path: "/examineUser",
    name: "examineUser",
    component: () => import("@/views/register-form/examineUser"),
  },
  {
    path: "/examinUserDetail",
    name: "examinUserDetail",
    component: () => import("@/views/register-form/examinUserDetail"),
  },
  {
    path: "/userLogin",
    name: "userLogin",
    component: () => import("@/views/register-form/userLogin"),
  },

  // 问卷页面
  {
    path: "/questionnaire",
    name: "questionnaire",
    component: () => import("@/views/register-form/questionnaire"),
  },

  // ADM 相关页面
  {
    path: "/adm/mideaRegister",
    name: "admMediaRegister",
    meta: {
      desc: "adm 媒体注册定制页面",
    },
    component: () => import("@/views/adm/mediaRegister"),
  },

  // ADM 相关页面
  {
    path: "/adm/webTomini",
    name: "admTicket",
    meta: {
      desc: "adm 媒体注册定制页面",
    },
    component: () => import("@/views/adm/webToAdmTicket"),
  },

  // ADM 相关页面
  {
    path: "/adm/businessCooperation",
    name: "businessCooperation",
    meta: {
      desc: "adm 商务合作表单",
    },
    component: () => import("@/views/adm/businessCooperation"),
  },
  {
    path: "/adm/businessCooperation2023",
    name: "businessCooperation",
    meta: {
      desc: "2024adm 商务合作表单",
    },
    component: () => import("@/views/adm/businessCooperation2023"),
  },

  // 二维码解析页面
  {
    path: "/qrCode",
    name: "qrCode",
    component: () => import("@/views/scanCode/qrCode"),
  },

  // 测试页面
  {
    path: "/testForm",
    name: "testForm",
    component: () => import("@/views/test"),
  },

  // 西博会媒体注册
  {
    path: "/xibo/mideaRegister",
    name: "xiboMediaRegister",
    meta: {
      desc: "xibo 媒体注册定制页面",
    },
    component: () => import("@/views/xibo/mediaRegister"),
  },

  // 自定义页面
  {
    path: "/customPage/questionnaire",
    name: "customPage",
    component: () => import("@/views/customPage/questionnaire"),
  },

  {
    path: "/customPage/orderTicket",
    name: "customPageOrderTicket",
    component: () => import("@/views/customPage/orderTicket"),
  },
  // 西博会预约门票
  {
    path: "/customPage/orderTicketByxibo",
    name: "customPageOrderTicketByxibo",
    component: () => import("@/views/customPage/orderTicketByxibo"),
  },
  // 发票申请
  {
    path: "/customPage/applyBill",
    name: "customPageApplyBill",
    component: () => import("@/views/customPage/applyBill"),
  },

  // 自定义图表
  {
    path: "/customPage/charts",
    name: "customPageCharts",
    component: () => import("@/views/customPage/charts"),
  },
  {
    path: "/jbh/charts",
    name: "jbhCharts",
    component: () => import("@/views/jbh/charts"),
  },

  // “xiao往全球”2023年纺织服装行业国际市场专场报名表
  {
    path: "/customPage/xiaoshanqinggong",
    name: "customPageXiaoshanQinggong",
    component: () => import("@/views/customPage/xiaoshanqinggong"),
  },
  // “xiao往全球”2023年纺织服装行业国际市场专场报名表
  {
    path: "/customPage/webTomini",
    name: "customPageWebTomini",
    component: () => import("@/views/customPage/webToMiniHome"),
  },

  // pass权益卡
  {
    path: "/customPage/passRegister",
    name: "customPagePassRegister",
    component: () => import("@/views/customPage/passRegister"),
  },
  {
    path: "/customPage/passWord",
    name: "customPagepassWord",
    component: () => import("@/views/customPage/passWord"),
  },

  // 数贸通
  {
    path: "/smt/webToMeet",
    name: "webToMeet",
    component: () => import("@/views/shumaotong/webToMeet"),
  },

  // 自定义播放器
  {
    path: "/customPage/videoPlayer",
    name: "customPageVideoPlayer",
    component: () => import("@/views/customPage/videoPlayer"),
  },
  // 管理后门(特殊通道)
  {
    path: "/customPage/specificChannel",
    name: "specificChannel",
    component: () => import("@/views/customPage/specificChannel"),
    meta: {
      desc: "管理后门",
    },
  },
  {
    path: "/customPage/deleteHealthCommitment",
    name: "deleteHealthCommitment",
    component: () => import("@/views/customPage/deleteHealthCommitment"),
    meta: {
      desc: "删除健康承诺书",
    },
  },

  // 生成微信小程序短链接公共页面
  {
    path: "/generatescheme",
    name: "generatescheme",
    component: () => import("@/views/webToMini/commonMiniScheme"),
  },
  {
    path: "/v/:code",
    name: "vcode",
    component: () => import("@/views/webToMini/commonMiniSchemeByMessage"),
  },

  // mehz 店铺核销逻辑
  {
    path: "/mehz/shopAccountBind",
    name: "shopAccountBind",
    component: () => import("@/views/mehz/shopAccountBind"),
    meta: {
      desc: "mehz 店铺核销优惠券",
    },
  },
  {
    path: "/mehz/shopCheck",
    name: "shopCheck",
    component: () => import("@/views/mehz/shopCheck"),
    meta: {
      desc: "mehz 店铺核销优惠券",
    },
  },
  // mehz 数据看板
  {
    path: "/mehz/dataShow",
    name: "dataShow",
    component: () => import("@/views/mehz/dataShow"),
    meta: {
      desc: "mehz 数据看板",
    },
  },

  // 健康承诺书相关
  {
    path: "/healthCommit/index",
    name: "healthCommitIndex",
    component: () => import("@/views/healthCommitment/index"),
    meta: {
      desc: "健康承诺书标准页面",
    },
  },

  // GDTE相关H5
  {
    path: "/gdte/visitorInvite",
    name: "visitotrInvite",
    component: () => import("@/views/gdteInvite/visitorInvite"),
    meta: {
      desc: "观众邀请函",
    },
  },
  {
    path: "/gdte/exhibitionInvite",
    name: "exhibitionInvite",
    component: () => import("@/views/gdteInvite/exhibitionInvite"),
    meta: {
      desc: "展商邀请函",
    },
  },
  {
    path: "/gdte/forumInvite",
    name: "forumInvite",
    component: () => import("@/views/gdteInvite/forumInvite"),
    meta: {
      desc: "论坛邀请函",
    },
  },
  {
    path: "/webToMini/webToGdte",
    name: "webToGdte",
    component: () => import("@/views/webToMini/webToGdte"),
    meta: {
      desc: "webToGdte 短链接",
    },
  },
  {
    path: "/customPage/healthReport",
    name: "healthReport",
    component: () => import("@/views/customPage/healthReport"),
    meta: {
      desc: "gdte 健康承诺书",
    },
  },
  {
    path: "/customPage/healthReportTest",
    name: "healthReportTest",
    component: () => import("@/views/customPage/healthReportTest"),
    meta: {
      desc: "gdte 健康承诺书备份",
    },
  },
  {
    path: "/customPage/fileQrCode",
    name: "fileQrCode",
    component: () => import("@/views/customPage/fileQrCode"),
    meta: {
      desc: "gdte 生成文件码",
    },
  },
  {
    path: "/customPage/gdteSubQuestion",
    name: "gdteSubQuestion",
    component: () => import("@/views/customPage/gdteSecondQuestion"),
    meta: {
      desc: "gdte 第二届报名表",
    },
  },
  {
    path: "/customPage/generateRegisterCode",
    name: "generateRegisterCode",
    component: () => import("@/views/customPage/generateRegisterCode"),
    meta: {
      desc: "gdte 生成小程序注册码",
    },
  },
  {
    path: "/customPage/chengguo",
    name: "chengguo",
    component: () => import("@/views/customPage/chengguo"),
    meta: {
      desc: "gdte 成果",
    },
  },
  {
    path: "/customPage/OpportunityCenter",
    name: "OpportunityCenter",
    component: () => import("@/views/customPage/OpportunityCenter"),
    meta: {
      desc: "gdte 商机会谈",
    },
  },
  {
    path: "/webToMini/webToMehzGdte",
    name: "webToMehzGdte",
    component: () => import("@/views/webToMini/webToMehzGdte"),
    meta: {
      desc: "gdte 进入mehz 数贸会首页端链接",
    },
  },
  // mehz 申请会议主办
  {
    path: "/webToMini/webToshiyongshenqing",
    name: "webToshiyongshenqing",
    component: () => import("@/views/webToMini/webToshiyongshenqing"),
    meta: {
      desc: "申请会议主办",
    },
  },
  // WeMeet 申请会议主办
  {
    path: "/webToMini/webToshiyongshenqingByWeMeet",
    name: "webToshiyongshenqingByWeMeet",
    component: () => import("@/views/webToMini/webToshiyongshenqingByWeMeet"),
    meta: {
      desc: "申请会议主办",
    },
  },
  // meetSG 申请会议主办
  {
    path: "/webToMini/webToshiyongshenqingBySG",
    name: "webToshiyongshenqingBySG",
    component: () => import("@/views/webToMini/webToshiyongshenqingBySG"),
    meta: {
      desc: "申请会议主办",
    },
  },

  // 动态表单生成器
  {
    path: "/form/generateForm",
    name: "generateForm",
    component: () => import("@/views/form/generateForm"),
    meta: {
      desc: "表单生成器",
    },
  },
  {
    path: "/form/getForm",
    name: "getForm",
    component: () => import("@/views/form/getForm"),
    meta: {
      desc: "表单填写区域",
    },
  },

  // 不用的定制化页面
  {
    path: "/notUse/meetSgDemo",
    name: "meetSgDemo",
    component: () => import("@/views/notUse/meetSgDemo"),
    meta: {
      desc: "sg 演示1",
    },
  },
  {
    path: "/notUse/meetSgDemo1",
    name: "meetSgDemo1",
    component: () => import("@/views/notUse/meetSgDemo1"),
    meta: {
      desc: "sg 演示2",
    },
  },
  // 上海ceo峰会日程列表
  {
    path: "/shCeo/summits",
    name: "summits",
    component: () => import("@/views/shCeo/summits"),
    meta: {
      desc: "上海ceo峰会日程列表",
    },
  },
  // 上海ceo峰会如何到达
  {
    path: "/shCeo/arrive",
    name: "arrive",
    component: () => import("@/views/shCeo/arrive"),
    meta: {
      desc: "上海ceo峰会如何到达",
    },
  },
  // 上海ceo峰会酒店预订
  {
    path: "/shCeo/hotelAddress",
    name: "hotelAddress",
    component: () => import("@/views/shCeo/hotelAddress"),
    meta: {
      desc: "上海ceo峰会酒店预订",
    },
  },
  // 上海ceo峰会联系我们
  {
    path: "/shCeo/contactUs",
    name: "contactUs",
    component: () => import("@/views/shCeo/contactUs"),
    meta: {
      desc: "上海ceo峰会联系我们",
    },
  },
  // 上海ceo峰会大会介绍
  {
    path: "/shCeo/meetIntroduce",
    name: "meetIntroduce",
    component: () => import("@/views/shCeo/meetIntroduce"),
    meta: {
      desc: "上海ceo峰会大会介绍",
    },
  },
  // 上海ceo峰会合作伙伴
  {
    path: "/shCeo/partner",
    name: "partner",
    component: () => import("@/views/shCeo/partner"),
    meta: {
      desc: "上海ceo峰会合作伙伴",
    },
  },
  // 外部网站--公用地图
  {
    path: "/outSitePage/commonMap",
    name: "commonMap",
    component: () => import("@/views/outSitePage/commonMap"),
    meta: {
      desc: "公用地图",
    },
  },
  // 外部网站--合作伙伴
  {
    path: "/outSitePage/partner",
    name: "outSitePagepartner",
    component: () => import("@/views/outSitePage/partner"),
    meta: {
      desc: "合作伙伴",
    },
  },
  // 外部网站--公共内容页
  {
    path: "/outSitePage/publicPage",
    name: "publicPage",
    component: () => import("@/views/outSitePage/publicPage"),
    meta: {
      desc: "公共内容页",
    },
  },
  //定制页面关于我们 ltepxo
  {
    path: "/outSitePage/ltexpoAbout",
    name: "ltexpoAbout",
    component: () => import("@/views/outSitePage/ltexpoAbout"),
    meta: {
      desc: "ltepxo about",
    },
  },
  //定制页面酒店 ltepxo
  {
    path: "/outSitePage/ltexpoAppoint",
    name: "ltexpoAppoint",
    component: () => import("@/views/outSitePage/ltexpoAppoint"),
    meta: {
      desc: "ltexpoAppoint",
    },
  },
  //定制页面酒店 ltepxo
  {
    path: "/outSitePage/ltexpoArrive",
    name: "ltexpoArrive",
    component: () => import("@/views/outSitePage/ltexpoArrive"),
    meta: {
      desc: "ltexpo Arrive",
    },
  },
  //定制贵州会议导航页
  {
    path: "/outSitePage/guizhouArrive",
    name: "guizhouArrive",
    component: () => import("@/views/outSitePage/guizhouArrive"),
    meta: {
      desc: "贵州会展中心导航",
    },
  },
  // gio埋点
  {
    path: "/growingIo",
    name: "growingIo",
    component: () => import("@/views/outSitePage/growingIo"),
    meta: {
      desc: "gio埋点",
    },
  },

  // 绑定用户结果
  {
    path: "/userBindResult",
    name: "userBindResult",
    component: () => import("@/views/userBindResult"),
  },
  // 微信绑定用户
  {
    path: "/userWechatLoginIndex",
    name: "userWechatLoginIndex",
    component: () => import("@/views/userWechatLoginIndex"),
  },

  // 二维码带小程序标识
  {
    path: "/qrCodeByIcon",
    name: "qrCodeByIcon",
    component: () => import("@/views/poster/qrCodeByIcon"),
  },
  {
    path: "/qrCodeByIconByName",
    name: "qrCodeByIconByName",
    component: () => import("@/views/poster/qrCodeByIconByName"),
  },
  // 动态转发图
  {
    path: "/poster/trendPoster",
    name: "trendPoster",
    component: () => import("@/views/poster/trendPoster"),
  },
  // 名片转发图
  {
    path: "/poster/businessCard",
    name: "businessCard",
    component: () => import("@/views/poster/businessCard"),
  },
  // 名片下载图
  {
    path: "/poster/myBusinessCard",
    name: "businessCard",
    component: () => import("@/views/poster/myBusinessCard"),
  },

  // 企业转发转发图
  {
    path: "/poster/enterPrisePoster",
    name: "enterPrisePoster",
    component: () => import("@/views/poster/enterPrisePoster"),
  },

  // 小程序页面-h5 开发

  {
    path: "/mini/charts",
    name: "charts",
    component: () => import("@/views/mini-page/charts/charts"),
  },
  {
    path: "/gdteInvite/exhOnsideQrcode",
    name: "exhOnsideQrcode",
    component: () => import("@/views/gdteInvite/exhOnsideQrcode"),
  },
  {
    path: "/gdteInvite/gdteBench",
    name: "gdteBench",
    component: () => import("@/views/gdteInvite/gdteBench"),
  },
  {
    path: "/gdteInvite/testvideo",
    name: "testvideo",
    component: () => import("@/views/gdteInvite/testvideo"),
  },
  // 动态表单落地页
  {
    path: "/formData",
    name: "formData",
    component: () => import("@/views/register-form/staticQuestionnaire"),
  },
  // 多语言 个人主页
  {
    path: "/multilingual/mainPage",
    name: "mainPage",
    component: () => import("@/views/multilingual/mainPage"),
  },

  // 小程序 H5 版本
  {
    path: "/mini-h5/index",
    name: "miniH5Index",
    component: () => import("@/views/mini-h5/pages/index"),
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/views/mini-h5/pages/home/index"),
      },
      {
        path: "mainPage",
        name: "miniH5MainPage",
        component: () => import("@/views/mini-h5/pages/user_home_page/index"),
      },
      {
        path: "myPage",
        name: "miniH5MyPage",
        component: () => import("@/views/mini-h5/pages/my_home_page/index"),
      },
      {
        path: "enterpriseMainPage",
        name: "miniH5MainPage",
        component: () =>
          import("@/views/mini-h5/pages/enterprise_home_page/index"),
      },
      {
        path: "enterpriseMainPageShare",
        name: "miniH5MainPageShare",
        component: () =>
          import("@/views/mini-h5/pages/enterprise_home_page/share"),
      },
      {
        path: "resumeList",
        name: "resumeList",
        component: () => import("@/views/mini-h5/pages/manager_resume/index"),
      },
      {
        path: "addResume",
        name: "addResume",
        component: () => import("@/views/mini-h5/pages/manager_resume/add"),
      },
      {
        path: "editIntroduce",
        name: "editIntroduce",
        component: () =>
          import("@/views/mini-h5/pages/manager_introduce/index"),
      },
      {
        path: "contactList",
        name: "contactList",
        component: () => import("@/views/mini-h5/pages/contacts/index"),
        meta: {
          title: "联系人列表",
        },
      },
      {
        path: "requestList",
        name: "requestList",
        component: () => import("@/views/mini-h5/pages/contacts/request"),
        meta: {
          title: "未处理的请求列表",
        },
      },
      {
        path: "exhibitsList",
        name: "exhibitsList",
        component: () => import("@/views/mini-h5/pages/exhibitor/exhibitsList"),
        meta: {
          title: "展品列表",
        },
      },
      {
        path: "exhibitsDetail",
        name: "exhibitsDetail",
        component: () =>
          import("@/views/mini-h5/pages/exhibitor/exhibitsDetail"),
        meta: {
          title: "展品列表",
        },
      },
      {
        path: "userLogin",
        name: "userLogin",
        component: () => import("@/views/mini-h5/pages/login/index"),
        meta: {
          title: "国际版登录页",
        },
      },
      {
        path: "emailLogin",
        name: "emailLogin",
        component: () => import("@/views/mini-h5/pages/login/emailLogin"),
        meta: {
          title: "国际版邮箱登录页",
        },
      },
      {
        path: "userRegister",
        name: "userRegister",
        component: () => import("@/views/mini-h5/pages/register/index"),
        meta: {
          title: "注册",
        },
      },
      {
        path: "emailCheck/:id",
        name: "emailCheck",
        component: () => import("@/views/mini-h5/pages/register/emailCheck"),
        meta: {
          title: "邮箱激活",
        },
      },
      {
        path: "group",
        name: "group",
        component: () => import("@/views/group/index.vue"),
      },
      {
        path: "productList",
        name: "productList",
        component: () => import("@/views/productList/index.vue"),
      },
      {
        path: "productDetail",
        name: "productDetail",
        component: () => import("@/views/productDetail/index.vue"),
      },
      {
        path: "groupDetail",
        name: "groupDetail",
        component: () => import("@/views/groupDetail/index.vue"),
      },
      {
        path: "invitePoster",
        name: "invitePoster",
        // /views/mini-h5/pages/register/emailCheck
        component: () => import("@/views/mini-h5/pages/invitePoster/index.vue"),
      },

      {
        path: "pdfPreview",
        name: "pdfPreview",
        // /views/mini-h5/pages/register/emailCheck
        component: () => import("@/views/mini-h5/pages/home/pdfPerview.vue"),
      },
    ],
  },
  {
    path: "/applyForm",
    name: "applyForm",
    component: () => import("@/views/apply-h5/applyForm/index"),
  },
  {
    path: "/applyFormByMeet",
    name: "applyFormByMeet",
    component: () => import("@/views/apply-h5/applyForm/holdMeet"),
  },
  {
    path: "/passage",
    name: "passage",
    component: () => import("@/views/apply-h5/applyForm/passage"),
  },
  {
    path: "/applyForm/login",
    name: "login",
    component: () => import("@/views/apply-h5/login/index"),
  },
  {
    path: "/preview",
    name: "preview",
    component: () => import("@/views/apply-h5/login/pdfPreview"),
  },
  {
    path: "/invitePoster",
    name: "invitePoster",
    component: () => import("@/views/invitePoster/index.vue"),
  },
  {
    path: "/newInvitePoster",
    name: "newInvitePoster",
    component: () => import("@/views/newInvitePoster/index.vue"),
  },
  {
    path: "/batchInvitePoster",
    name: "batchInvitePoster",
    component: () => import("@/views/newInvitePoster/batchInvitePoster.vue"),
  },
  {
    path: "/notification",
    name: "notification",
    component: () => import("@/views/notification/index.vue"),
  },
  {
    path: "/wemeetBill",
    name: "wemeetBill",
    component: () => import("@/views/customPage/wemeetApplyBill.vue"),
  },
  {
    path: "/jbhMapBr",
    name: "jbhMapBr",
    component: () => import("@/views/jbh/map1.vue"),
  },
  {
    path: "/jbhMapld",
    name: "jbhMapld",
    component: () => import("@/views/jbh/map2.vue"),
  },
  {
    path: "/jbhMapnew",
    name: "jbhMapnew",
    component: () => import("@/views/jbh/map3.vue"),
  },
  {
    path: "/jbhform",
    name: "form",
    component: () => import("@/views/jbh/form.vue"),
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const needLoginPath = ["/mini-h5/index/myPage"];
  const loginPath = [
    "/mini-h5/index/emailLogin",
    "/mini-h5/index/userLigin",
    "/mini-h5/index/userRegister",
    "/applyForm/login",
    "/preview",
  ];
  let token = localStorage.getItem("token");
  if (!!token) {
    Vue.prototype.$eventBus.$emit("refreshCountNum");
  }
  console.log(to, from, loginPath.indexOf(to.path) > -1);
  // 判断是否进入注册页，进入注册页面，缓存当前页面路由
  if (loginPath.indexOf(to.path) > -1 && loginPath.indexOf(from.path) < 0) {
    console.log("我是进入登录页面");
    localStorage.setItem("loginRedircet", from.fullPath);
  }

  if (needLoginPath.indexOf(to.path) >= 0 && !token) {
    next("/mini-h5/index/emailLogin");
  }
  next();
});

export default router;
